import styled from "styled-components";

const ItemReceiptPanelStyled = styled.div`

`;

export default ItemReceiptPanelStyled;